import React from 'react';
import { LandingPageConfig } from '../../../../generated/landing-page-config-schemas/v1/type';

import { Box, Container, Typography } from '@mui/material';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import HorizontalScrollContainer from '../../components/HorizontalScrollContainer';

type Props = Extract<
  LandingPageConfig['data']['slices'][number],
  { type: 'testimonials' }
> & {
  backgroundColor: string;
};
type Quote = Props['quotes'][number];

const Testimonials: React.FC<Props> = (props) => {
  const { title, quotes, backgroundColor } = props;

  return (
    <Box
      sx={{
        backgroundColor,
        py: 8,
      }}
    >
      <Container disableGutters>
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '32px', md: '48px' },
            fontWeight: 600,
            textAlign: { xs: 'left', md: 'center' },
            px: { xs: 4, md: 0 },
            mb: 6,
          }}
        >
          {title}
        </Typography>

        <HorizontalScrollContainer itemCount={quotes.length}>
          {quotes.map((quote: Quote, index: number) => (
            <Box
              key={index}
              sx={{
                width: { xs: '75vw', md: '380px' },
                flexShrink: 0,
                scrollSnapAlign: { xs: 'start', md: 'none' },
                backgroundColor: '#FFFFFF',
                border: '1px solid #E5E5E5',
                borderRadius: '16px',
                padding: '24px',
                display: 'flex',
                flexDirection: 'column',
                minHeight: '380px',
              }}
            >
              <FormatQuoteIcon
                sx={{
                  fontSize: '48px',
                  color: '#A3A3A3',
                  mb: 2,
                }}
              />
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: '18px', md: '24px' },
                  whiteSpace: 'pre-line',
                }}
              >
                {quote.quote}"
              </Typography>
              <Box sx={{ mt: 'auto', pt: 4 }}>
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: '18px', md: '24px' },
                    fontWeight: 600,
                    mb: 0.5,
                  }}
                >
                  {quote.name}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: '20px',
                    color: '#666666',
                  }}
                >
                  {quote.role}
                </Typography>
              </Box>
            </Box>
          ))}
        </HorizontalScrollContainer>
      </Container>
    </Box>
  );
};

export default Testimonials;
